import type { MarkerBaseEditor, MarkerBase } from '@markerjs/markerjs3'

let classes: {
  LaserPointerMarkerEditor: typeof MarkerBaseEditor<MarkerBase>
  LaserPointerMarker: typeof MarkerBase
} | null = null

let isActivated = false

export const useMarkerjs3 = async () => {
  const isClient = typeof window !== 'undefined'

  if (!isClient) {
    throw new Error('useMarkerjs3 can only be used in a client-side environment.')
  }

  if (!window.markerjs3) {
    throw new Error(
      'MarkerJS3 is not available on the window object. Ensure it is loaded before using this composable.',
    )
  }

  const markerjs3 = window.markerjs3

  if (!markerjs3) {
    throw new Error('MarkerJS3 is not loaded. Please ensure it is included in your project.')
  } else if (!isActivated) {
    markerjs3.Activator.addKey('MJS3', 'MJS3-F053-S399-5989')
    isActivated = true
  }

  if (!classes) {
    const { LaserPointerMarkerEditor, LaserPointerMarker } = await import(
      '@collection-player/composables/laser-pointer-marker.use.ts'
    )

    classes = {
      LaserPointerMarkerEditor,
      LaserPointerMarker,
    }
  }

  return {
    markerjs3,
    laserPointer: classes,
  }
}
